// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".legacy." + {"331":"ceb5416ff9bfefac5581","430":"fd577c0103cbcd07c81b","881":"9897a6c68e6b6e3cfb3b"}[chunkId] + ".js";
};